import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { chameleon } from '@/lib/chameleon'
import { evalKeys } from '@/lib/queryKeys'
import { enqueueEvalCaseRuns } from '../api'

const NO_AUTH_TOKEN_ERROR = 'No authentication token available'

export function useStartEvalCaseRunsMutation() {
  const { getToken } = useAuth()
  const { organization } = useOrganization()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (caseIds: string[]) => {
      const token = await getToken()
      if (!token) throw new Error(NO_AUTH_TOKEN_ERROR)
      return enqueueEvalCaseRuns(token, caseIds)
    },
    // Tracked in the shared mutation so all three call sites are covered at once.
    onSuccess: () => chameleon.track('Eval Run Started'),
    onSettled: (_data, _error, caseIds) => {
      for (const caseId of caseIds) {
        void queryClient.invalidateQueries({
          queryKey: evalKeys.caseRuns(organization?.id, caseId),
        })
      }
      void queryClient.invalidateQueries({
        queryKey: evalKeys.runs(organization?.id),
      })
    },
  })
}
